// react_frontend/src/Components/Modules/ChoosePackage.js
import React from "react";
import { useNavigate } from "react-router-dom";

const ChoosePackage = () => {
  const navigate = useNavigate();

  return (
    <div className="vh-100 d-flex align-items-center justify-content-center">
      <div className="card p-4 shadow text-center" style={{ width: "400px" }}>
        <h5 className="mb-3">Trial Expired</h5>
        <p className="text-muted mb-4">
          To continue using POS SaaS, please subscribe.
        </p>
        <a
          href="https://softsolutionmedia.gumroad.com/l/pos"
          //target="_blank"
          rel="noopener noreferrer"
          className="btn btn-success w-100 mb-3"
        >
          💳 Subscribe Now
        </a>
        <p className="small text-muted">
          After payment, your account will be activated automatically within 5 minutes. All information will be send to your email.
        </p>
        <button
          className="btn btn-secondary w-100"
          onClick={() => navigate("/login")}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
};

export default ChoosePackage;